





























import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import Skills from '@/components/Skills/Skills.vue'
import Alert from '@/components/Shared/Alert.vue'
import GiganautVue from '@/components/Shared/GiganautVue'
import PageNames from '@/router/PageNames';


@Component({
	name: 'AgencySkillSettings',
  	components: { Skills, Alert }
})
export default class extends GiganautVue {

	beforeMount() {
		AgencySettingsModule.getSkills();
  	}

	navigateToAgencySettings() {
		this.$router.push({ name: PageNames.AgencySettings });
	}

  	get loading() {
		return AgencySettingsModule.loadingSkills;
  	}
}
